<script setup lang="ts">
  import {
    IconThemeDark,
    IconSunrise,
    IconSunDim,
    IconThemeLight,
    IconSunMedium,
    IconSunset,
    IconMoon
  } from '../lucide-icons'
  import { computed, type HTMLAttributes } from 'vue'
  import { cn } from '../cn'

  const props = defineProps<{
    class?: HTMLAttributes['class']
    /** Time string in "HH:MM" or "HH:MM:SS" format */
    time: string
  }>()

  const _icon = computed(() => {
    const hour = parseInt(props.time.slice(0, 2), 10)
    if (hour < 5) return IconThemeDark
    if (hour < 7) return IconSunrise
    if (hour < 10) return IconSunDim
    if (hour < 14) return IconThemeLight
    if (hour < 17) return IconSunMedium
    if (hour < 19) return IconSunDim
    if (hour < 21) return IconSunset
    return IconMoon
  })
</script>

<template>
  <component :is="_icon" :class="cn('size-4', props.class)" />
</template>
